import { render, staticRenderFns } from "./HelpHeader.vue?vue&type=template&id=3e764708&scoped=true&"
import script from "./HelpHeader.vue?vue&type=script&lang=js&"
export * from "./HelpHeader.vue?vue&type=script&lang=js&"
import style0 from "./HelpHeader.vue?vue&type=style&index=0&id=3e764708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e764708",
  null
  
)

export default component.exports